import { render, staticRenderFns } from "./GraficBarres.vue?vue&type=template&id=16ea5f3a&"
import script from "./GraficBarres.vue?vue&type=script&lang=js&"
export * from "./GraficBarres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports